import script from "./VolunteeringEventItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteeringEventItem.vue?vue&type=script&setup=true&lang=js"

import "./VolunteeringEventItem.vue?vue&type=style&index=0&id=c34e3dc8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c34e3dc8"]])

export default __exports__